<template>
  <div>
    <router-view></router-view>
    <Footer></Footer>
  </div>
</template>

<script>
export default {
  name: "App",
 async mounted() {
    //App的根组件挂载完毕,发一次请求即可.
   await this.$store.dispatch("getTypeNavList");
    this.$store.dispatch("getFloorList");
  }
};
</script>

<style>
</style>
